<div class="loading-screen">Processing. Please Wait{{ loadingEllipsis | async}}</div>